import { render, staticRenderFns } from "./WithdrawCreate.vue?vue&type=template&id=c4bcbfd6&"
import script from "./WithdrawCreate.vue?vue&type=script&lang=js&"
export * from "./WithdrawCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports